export const SET_BID = 'SET_BID';
export const UPDATE_BID = 'UPDATE_BID';
